import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Build 3 · ¿La entidad opera factoraje? (producto de factoraje, deudor marcado o crédito de factoraje).
export function useFactorajeHabilitado(activo = true) {
  const [habilitado, setHabilitado] = useState(false);
  useEffect(() => {
    if (!activo) return undefined;
    let on = true;
    api.get("/factoraje/habilitado")
      .then((r) => { if (on) setHabilitado(!!r.data?.habilitado); })
      .catch(() => { if (on) setHabilitado(false); });
    return () => { on = false; };
  }, [activo]);
  return habilitado;
}
